export type ReceivedProps = Record<string, any>;

const useCustomerCategoryStatus = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useCustomerCategoryStatus>;

export default useCustomerCategoryStatus;
